
import BRadioGroup from 'Src/js/components/blain-form/BRadioGroup.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'LookupRadio',
	components: {
		BRadioGroup,
	}
})
class LookupRadio extends Vue {
	@Prop({ type: String, required: true })
	label: string;

	@Prop({ type: String, default: '' })
	rootClass: string;
}

export default LookupRadio;
